import {Component, OnInit} from "@angular/core";
import {UserService} from "../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {UserDto} from "../../../models/user-dto";
import {HttpErrorResponse} from "@angular/common/http";
import {Auth2Service} from "../../../services/auth2.service";
import {ApiService} from "../../../services/api.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-create-consultant-user',
  templateUrl: './create-consultant-user.component.html',
  styleUrls: ['./create-consultant-user.component.scss'],
  standalone: false
})
export class CreateConsultantUserComponent implements OnInit {
  breadCrumbs = [
    { label: 'Login', path: '/app/login'},
    { label: 'Create Consultant User'}
  ];

  showMessages: boolean = false;
  messages: any[] = [];

  showSuccessMessages: boolean = false;
  successMessages: any[] = [];

  loadingIcon: boolean = false;

  statesList: any[] = [];

  profileName = 'Create Consultant Profile';
  savedUserId: string = '-1';
  savedUsername: string = '';
  savedPassword: string = '';
  savedFirstName: string = '';
  savedLastName: string = '';
  savedPhoneNumber: string = '';
  savedEmail:string = '';
  savedEIN: string = '999999999';
  savedCompanyName: string = '';
  //Physical Address for Stripe Integration
  savedAddressLine1: string = '';
  savedAddressLine2: string = '';
  savedAddressLine3: string = '';
  savedCity: string = '';
  savedState: string = '';
  savedCountry: string = 'UNITED STATES';
  savedZipCode: string = '';
  savedCause: string = 'CONSULTING';
  savedIsConsultant: string = 'Y';
  savedJobTitle: string = '';
  termsAndConditionsObj: any = null;
  termsAndConditionsRadioButton: boolean = false;
  savedInvitedByClientBeforeJoining = 'N';

  legalDocumentDisplayNameTemp: string = '';
  //legalDocumentTxtTemp: string = '';
  legalDocumentTxtList: string[] = [];
  username: string = '';

  preConsultantEmail: string = '';
  referralCode: string = '';
  verified: boolean = false;
  verifyButtonClicked: boolean = false;
  savedConsultantId: number = -1;

  // @ts-ignore
  constructor(private userService: UserService,
              private router: Router,
              private route: ActivatedRoute,
              private auth2Service: Auth2Service,
              private apiService: ApiService,
              private titleService: Title) {
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.populateUSAStates();
    this.titleService.setTitle("Scalanthropy Create Consultant User Profile");
    this.savedUserId = this.auth2Service.getUserId();
    this.username = this.auth2Service.getUsername();
    this.profileName = 'Create Consultant User Profile';
  }

  verifyConsultantReferralCodeAtRegistration(): void {
    this.messages = [];
    const consultantEmailEl = document.getElementById('consultant-email-text-id');
    // @ts-ignore
    this.preConsultantEmail = consultantEmailEl.value;

    const referralCodeEl = document.getElementById('referral-code-text-id');
    // @ts-ignore
    this.referralCode = referralCodeEl.value;
    this.loadingIcon = true;
    this.verifyButtonClicked = true;
    this.userService.verifyConsultantReferralCodeAtRegistration(this.preConsultantEmail, this.referralCode)
      .subscribe((result: any) => {
        if (result && result.body) {
          this.verified = true;
          this.loadingIcon = false;
          if (result.body.userDto && result.body.userDto.consultantActive == 'Y') {
            this.showSuccessMessages = true;
            this.successMessages.push({
              field: 'Client and Consultant verified',
              detail: 'Client and Consultant verified successfully! You already have a user account. Please login through the portal. Redirecting you now.',
              severity: 'success'
            });
            setTimeout(() => {
              this.router.navigateByUrl('app/consultants/referral-code/success');
            }, 4000);
          } else {
            setTimeout(() => {
              this.savedInvitedByClientBeforeJoining = result.body.invitedByClientBeforeJoining;
              if (result.body.invitedByClientBeforeJoining == 'Y') {
                this.populateOnlyEmail(result.body)
              } else {
                this.populateData(result.body);
              }
            }, 2000);
          }
        }
      }, (error: HttpErrorResponse) => {
        this.verified = false;
        this.loadingIcon = false;
        this.verifyButtonClicked = false;
        this.messages.push({
          field: 'Failed to verify the consultant email or referral code',
          detail: 'Failed to verify the consultant email or referral code. ' + error.error.message,
          severity: 'error'
        });
        this.showMessagesToUser();
      })


  }
  toggleLegalAgreement(): void {
    this.termsAndConditionsRadioButton = !this.termsAndConditionsRadioButton;
  }

  private populateOnlyEmail(dto: any): void{
    this.savedEmail = this.preConsultantEmail;
    this.savedUsername = this.preConsultantEmail;
    const emailEl = document.getElementById('email-text-id');
    // @ts-ignore
    emailEl.value = this.preConsultantEmail;
    const confirmedEmailEl = document.getElementById('confirm-email-text-id');
    // @ts-ignore
    confirmedEmailEl.value = this.preConsultantEmail;


    this.savedConsultantId = dto.consultantId

  }

  /**
   * Populate from consultants table
   * @private
   * @param consultantDto
   */
  private populateData(dto: any) {
    let userDto: any = null;
    if (dto.userDto) {
      userDto = dto.userDto
    } else {
      userDto = dto;
    }
    this.savedUserId = userDto.userId;

    this.savedConsultantId = dto.consultantId;

    if (userDto.firstName) {
      this.savedFirstName = userDto.firstName;
      const firstNameEl = document.getElementById('first-name-text-id');
      // @ts-ignore
      firstNameEl.value = this.savedFirstName;
    }

    if (userDto.lastName) {
      this.savedLastName = userDto.lastName;
      const lastNameEl = document.getElementById('last-name-text-id');
      // @ts-ignore
      lastNameEl.value = this.savedLastName;
    }

    if (userDto.email) {
      this.savedEmail = userDto.email;
      this.savedUsername = userDto.email;
      const emailEl = document.getElementById('email-text-id');
      // @ts-ignore
      emailEl.value = this.savedEmail;
      const confirmedEmailEl = document.getElementById('confirm-email-text-id');
      // @ts-ignore
      confirmedEmailEl.value = this.savedEmail;
    }

    if (userDto.phoneNumber) {
      this.savedPhoneNumber = userDto.phoneNumber;
      const phoneNumberEl = document.getElementById('phone-number-text-id');
      // @ts-ignore
      phoneNumberEl.value = this.savedPhoneNumber;
    }

    if (userDto.companyName) {
      this.savedCompanyName = userDto.companyName;
      const companyNameEl = document.getElementById('company-name-text-id');
      // @ts-ignore
      companyNameEl.value = this.savedCompanyName;
    }

    /*
    if (userDto.addressLine1) {
      this.savedAddressLine1 = userDto.addressLine1;
      const addressLine1El = document.getElementById('address-line-1-text-id');
      // @ts-ignore
      addressLine1El.value = this.savedAddressLine1;
    }

    if (userDto.addressLine2) {
      this.savedAddressLine2 = userDto.addressLine2;
      const addressLine2El = document.getElementById('address-line-2-text-id');
      // @ts-ignore
      addressLine2El.value = this.savedAddressLine2;
    }

    if (userDto.addressLine3) {
      this.savedAddressLine3 = userDto.addressLine3;
    }

    if (userDto.city) {
      this.savedCity = userDto.city;
      const cityEl = document.getElementById('city-text-id');
      // @ts-ignore
      cityEl.value = this.savedCity;
    }

    if (userDto.state) {
      this.savedState = userDto.state;
      const stateEl = document.getElementById('usa-dropdown-list-id');
      // @ts-ignore
      stateEl.value = this.savedState;
    }

    if (userDto.country) {
      this.savedCountry = userDto.country;
    }

    if (userDto.zipCode) {
      this.savedZipCode = userDto.zipCode;
      const zipCodeEl = document.getElementById('zip-code-text-id');
      // @ts-ignore
      zipCodeEl.value = this.savedZipCode;
    }*/

    if (dto.jobTitle) {
      this.savedJobTitle = dto.jobTitle;
      const jobTitleEl = document.getElementById('job-title-text-id');
      // @ts-ignore
      jobTitleEl.value = this.savedJobTitle;
    }
  }

  populateUSAStates(): void {
    this.statesList = [];
    this.userService.getUSAStatesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.statesList.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.messages.push({
        field: 'USA States Dropdown Failure',
        detail: 'Failed to pull the USA States',
        severity: 'error'
      });
      this.showMessagesToUser();
    })
  }

  onCancel(): void {
    this.router.navigateByUrl('app/login');
  }

  showMessagesToUser(delayTime: number = 8000): void {
    this.showMessages = true;
    const counterFn = () => {
      this.showMessages = false;
    }
    setTimeout(counterFn, delayTime);
  }

  showSuccessMessagesToUser(delayTime: number = 8000): void {
    this.showSuccessMessages = true;
    const counterFn = () => {
      this.showSuccessMessages = false;
    }
    setTimeout(counterFn, delayTime);
  }

  checkoutSessionConsultantV3(): void {
    this.messages = [];

    this.userService.checkoutSessionUpdatePaymentMethodV3(this.savedEmail)
      .subscribe((result: any) => {
        if (result && result.body && result.body.url) {
          //Checkout Started
          this.successMessages.push({
            field: 'Checkout Session',
            detail: 'Checkout Session Started.',
            severity: 'success'
          });
          this.showMessagesToUser();
          // @ts-ignore
          window.open(result.body.url, '_self');
        } else {

        }
      }, (err1: HttpErrorResponse) => {
        if (err1.status == 400) {
          this.messages.push({
            field: 'Subscription Plan Promo Code Error',
            detail: err1.error.message + '. Your account though has been created. Redirecting to subscription selection.',
            severity: 'error'
          });
        } else {
          this.messages.push({
            field: 'Subscription Plan Checkout Session API Error',
            detail: 'Failed to create a checkout session. ' + err1.error.message + ' Your account though has been created. Redirecting to subscription selection.',
            severity: 'error'
          });
        }
        this.showMessagesToUser(8000);
        //Redirect to Subscription payments and checkout.
        this.router.navigateByUrl('app/users/dashboard/subscription/pricing/pay');
      });
  }

  onSave(): void {
    this.showMessages = false;
    this.showSuccessMessages = false;
    this.messages = [];
    this.successMessages = [];
    //Validate First Name
    const firstNameEl = document.getElementById('first-name-text-id');
    // @ts-ignore
    let firstName = firstNameEl.value;
    if (!firstName) {
      this.messages.push({
        field: 'First Name',
        detail: 'First Name: ' + firstName + ' must not be empty.',
        severity: 'error'
      });
    }
    firstName = this.apiService.trimLeadingTrailingSpaces(firstName)
    if (firstName && firstName.length < 2 && firstName.length > 50) {
      this.messages.push({
        field: 'First Name',
        detail: 'First Name: ' + firstName + ' is not valid. The First Name must be 2 between 40 alphabetical characters, including dashes and spaces.',
        severity: 'error'
      });
    }
    this.savedFirstName = firstName;

    //Validate Last Name
    const lastNameEl = document.getElementById('last-name-text-id');
    // @ts-ignore
    let lastName = lastNameEl.value;
    if (!lastName) {
      this.messages.push({
        field: 'Last Name',
        detail: 'Last Name: ' + lastName + ' must not be empty.',
        severity: 'error'
      })
    }
    lastName = this.apiService.trimLeadingTrailingSpaces(lastName);
    if (lastName && lastName.length < 2 && lastName.length > 50) {
      this.messages.push({
        field: 'Last Name',
        detail: 'Last Name: ' + lastName + ' is not valid. The Last Name must be 2 between 40 alphabetical characters, including dashes and spaces.',
        severity: 'error'
      })
    }
    this.savedLastName = lastName;

    //Validate email
    const emailEl = document.getElementById('email-text-id');
    // @ts-ignore
    const email = emailEl.value;
    if (!email) {
      this.messages.push({
        field: 'Email',
        detail: 'Email: ' + email + ' is not valid.',
        severity: 'error'
      })
    }
    this.savedEmail = this.apiService.trimLeadingTrailingSpaces(email);

    //Validate Phone Number
    const phoneNumberEl = document.getElementById('phone-number-text-id');
    // @ts-ignore
    const phoneNumber = phoneNumberEl.value;
    if (!phoneNumber) {
      this.messages.push({
        field: 'Phone Number',
        detail: 'Phone Number: ' + phoneNumber + ' must not be empty.',
        severity: 'error'
      })
    }
    let modPhoneNumber: string = phoneNumber.replaceAll("-", "");
    modPhoneNumber = modPhoneNumber.replaceAll(" ", "");
    modPhoneNumber = modPhoneNumber.replaceAll("(", "");
    modPhoneNumber = modPhoneNumber.replaceAll(")", "");
    if (modPhoneNumber && modPhoneNumber.length != 10) {
      this.messages.push({
        field: 'Phone Number',
        detail: 'Phone Number: ' + phoneNumber + ' is not valid. The Phone Number must be exactly 10 digits and must be a US phone number.',
        severity: 'error'
      })
    }
    this.savedPhoneNumber = modPhoneNumber;

    //Validate Company Name
    const companyNameEl = document.getElementById('company-name-text-id');
    // @ts-ignore
    const companyName = companyNameEl.value;
    if (!companyName) {
      this.messages.push({
        field: 'Company Name',
        detail: 'Company Name: ' + companyName + ' is not valid.',
        severity: 'error'
      })
    }
    this.savedCompanyName = this.apiService.trimLeadingTrailingSpaces(companyName);

    const jobTitleEl = document.getElementById('job-title-text-id');
    // @ts-ignore
    const jobTitle = jobTitleEl.value;
    if (!jobTitle) {
      this.messages.push({
        field: 'Job Title',
        detail: 'Job Title: ' + jobTitle + ' must not be empty.',
        severity: 'error'
      })
    }
    this.savedJobTitle = this.apiService.trimLeadingTrailingSpaces(jobTitle);

    //Validate Physical Address
    //Address Line 1
    /*
    const addressLine1El = document.getElementById('address-line-1-text-id');
    // @ts-ignore
    const addressLine1: string = addressLine1El.value;
    if (!addressLine1) {
      this.messages.push({
        field: 'AddressLine1',
        detail: 'AddressLine1: ' + addressLine1 + ' is not valid and must not be empty.',
        severity: 'error'
      })
    }
    this.savedAddressLine1 = this.apiService.trimLeadingTrailingSpaces(addressLine1);*/
    this.savedAddressLine1 = 'N/A';

    /*
    const addressLine2El = document.getElementById('address-line-2-text-id');
    // @ts-ignore
    const addressLine2: string = addressLine2El.value;
    this.savedAddressLine2 = addressLine2;*/
    this.savedAddressLine2 = 'N/A';

    //const addressLine3El = document.getElementById('address-line-3-text-id');
    // @ts-ignore
    /*
    const addressLine3: string = '';
    this.savedAddressLine3 = addressLine3;*/
    this.savedAddressLine3 = 'N/A';

    /*
    const cityEl = document.getElementById('city-text-id');
    // @ts-ignore
    const city = cityEl.value;
    if (!city) {
      this.messages.push({
        field: 'City',
        detail: 'City: ' + city + ' must not be empty.',
        severity: 'error'
      })
    }
    this.savedCity = this.apiService.trimLeadingTrailingSpaces(city);*/
    this.savedCity = 'N/A';

    /*
    const stateEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    const state: string = stateEl.value;
    if (!state) {
      this.messages.push({
        field: 'State',
        detail: 'State: ' + state + ' must not be empty.',
        severity: 'error'
      })
    }
    this.savedState = this.apiService.trimLeadingTrailingSpaces(state);*/
    this.savedState = 'AR';

    /*
    const zipCodeEl = document.getElementById('zip-code-text-id');
    // @ts-ignore
    let zipCode: string = zipCodeEl.value;
    if (!zipCode) {
      this.messages.push({
        field: 'Zip Code',
        detail: 'Zip code: ' + zipCode + ' must not be empty.',
        severity: 'error'
      });
    } else {
      zipCode = zipCode.replace("-", "");
      zipCode = this.apiService.trimLeadingTrailingSpaces(zipCode)
      if (zipCode.length != 5 && zipCode.length != 9) {
        this.messages.push({
          field: 'Zip Code',
          detail: 'Zip code: ' + zipCode + ' can only be 5 digits or 9 digits.',
          severity: 'error'
        });
      }
    }
    this.savedZipCode = zipCode;*/
    this.savedZipCode = '99999';

    let passwordEl = document.getElementById('password-text-id');
    // @ts-ignore
    let password = passwordEl.value;
    let repeatPasswordEl = document.getElementById('password-repeat-text-id');
    // @ts-ignore
    let repeatPassword = repeatPasswordEl.value;
    if (password !== repeatPassword) {
      this.messages.push({
        field: 'password',
        detail: 'Passwords do NOT match.',
        severity: 'error'
      });
    }

    if (this.messages.length > 0 || !this.termsAndConditionsRadioButton) {
      this.showMessagesToUser();
      return;
    }

    let userId = -1;
    if (this.savedUserId) {
      userId = parseInt(this.savedUserId);
    }

    let userDto: UserDto = {
      "userId": userId,
      "username": this.savedEmail,
      "password": password,
      "pwhash": '',
      "firstName": this.savedFirstName,
      "lastName": this.savedLastName,
      "phoneNumber": this.savedPhoneNumber,
      "email": this.savedEmail,
      "nonprofitDonorEin": this.savedEIN,
      "companyName": this.savedCompanyName,
      "isConsultant": this.savedIsConsultant,
      "addressLine1": this.savedAddressLine1,
      "addressLine2": this.savedAddressLine2,
      "addressLine3": this.savedAddressLine3,
      "city": this.savedCity,
      "state": this.savedState,
      "country": this.savedCountry,
      "zipCode": this.savedZipCode,
      "additionalUsernames": [],
      "cause": this.savedCause,
      "consultantId": -1,
      "consultantEmail": "",
      "consultantReferralCode": "",
      "consultantReferralCodeVerified": "",
      "consultantRoleName": "",
      "consultantDisplayRoleName": "",
      "consultantAutoRenewal": "Y"
    }

    let consultantUserDto: any = {
      "userDto": userDto,
      "consultantId": this.savedConsultantId,
      "jobTitle": this.savedJobTitle,
      "invitedByClientBeforeJoining": this.savedInvitedByClientBeforeJoining
    };

      //submit API
    this.successMessages.push({
      field: 'Consultant Account Creation',
      detail: 'Consultant Account Creation Started. Please wait.',
      severity: 'success'
    });
    this.showSuccessMessages = true;
    this.userService.createConsultantUserV3(consultantUserDto).subscribe((result: any) => {
      if (result && result.body) {
        //Account has been created successfully
        this.successMessages.push({
          field: 'Consultant Account Creation',
          detail: 'Consultant Account Successfully Created',
          severity: 'success'
        });
        this.showSuccessMessagesToUser();

        this.auth2Service.cacheSessionFull(result.body)
        //Submit Legal Agreement for records
        this.savedUsername = result.body.email;
        localStorage.setItem('username', this.savedEmail);
        this.userService.createUserTermsAndConditionsLegalAgreement(this.savedEmail)
          .subscribe((result2: any) => {
            if (result2 && result2.body && result2.body.agreed) {
              //Legal Agreement Recorded
              this.successMessages.push({
                field: 'Legal Agreement',
                detail: 'Legal Agreement Successfully Recorded.',
                severity: 'success'
              });
              //Checkout URL Link Generation Started
              this.successMessages.push({
                field: 'Checkout URL Link',
                detail: 'Checkout URL Link Generation Started.',
                severity: 'success'
              });
              this.checkoutSessionConsultantV3();
            }
          }, (err2: HttpErrorResponse) => {
            this.messages.push({
              field: 'username / email',
              detail: 'Error creating Agreement Entry for Terms and Conditions for consultant email: ',
              severity: 'error'
            });
            this.showMessagesToUser();
          });
      }
    }, (err: HttpErrorResponse) => {
      const errorList: string[] = err.error.errors;
      let i: number = 0;
      while (i < errorList.length) {
        this.messages.push({
          field: 'Username Creation Error',
          detail: errorList[i],
          severity: 'error'
        });
        i = i + 1;
      }
      this.showMessagesToUser();
      this.successMessages = [];
      this.showSuccessMessages = false;
    });

  }
}
